import { MakeQueryString } from 'front-utility';
import { ApiRoute } from 'api-base-refrence';
import { NestjsPageFilter } from 'nestjs-model-utility';
import { SystemConfigModel } from 'src/domains/site-managment/model/system-config/system-config.model';
import { SystemConfigApiRoute } from 'src/domains/site-managment/app/api-routes/system-config/system-config.api';

export class SystemConfigFilterApiRoute extends ApiRoute {
  static apiName = '';
  static parent = SystemConfigApiRoute;
  static urlPattern(filter?: NestjsPageFilter<keyof SystemConfigModel.Index>) {
    return `?${MakeQueryString(filter)}`;
  }
}
